import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import SendLetter from "../../Icons/SendLetter";
import FollowCall from "../../Icons/FollowCall";
import { connect } from 'react-redux';
import { letterOrderStatusText } from "../../../utils/utils";
import SalesforceSyncStatus from "../parts/SalesforceSyncStatus";
import { ORDER_TYPES } from "../../../constants/OrderValues";
import { FLAG } from "../../../constants/Constants";

const styles = () => ({
  root: {
    fontSize: "16px",
    color: "#181819",
    fontWeight: "bold",
    paddingBottom: "9px",
    borderBottom: "1px solid #E7E9EB",
    marginBottom: "28px",
    display: "flex",
    alignItems: "center",
    width: "100%",
  },

  icon: {
    width: "32px",
    height: "32px",
    minWidth: "32px",
    background: "#F2F6FF",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "8px",
  },

  flex: {
    flex: 1,
  },
});

class ItemTitle extends React.Component {
  render() {
    const { classes, isLoading, item, user } = this.props;

    return (
      <div className={classes.root}>
        {/* アイコンを表示 */}
        <div className={classes.icon} style={{ backgroundColor: "#F2F6FF" }}>
          {(() => {
            if (isLoading) {
              return "";
            } else if (item && item.letter_order) {
              return <SendLetter width={12} height={12} color="#6F9EFF" />;
            } else if (item && item.follow_call_order) {
              return <FollowCall width={12} height={12} color="#6F9EFF" />;
            } else {
              return "";
            }
          })()}
        </div>

        {/* タイトルを表示 */}
        {(() => {
          if (isLoading) {
            return "";
          } else if (item && item.letter_order) {
            return letterOrderStatusText(item.letter_order);
          } else if (item && item.follow_call_order) {
            return "フォローコールが注文されました。";
          } else {
            return "注文されました。";
          }
        })()}

        {/* 余白 */}
        <div className={classes.flex}></div>

        {/* レター注文のSalesforce関連を表示 */}
        {!isLoading && item && item.letter_order && (item.letter_order.salesforce_sync_flag === FLAG.ON || item.letter_order.salesforce_sync_flag === FLAG.FAILED) && user && user.salesforce_integration_flag === 1 && (
          <SalesforceSyncStatus
            item={item.letter_order}
            type={ORDER_TYPES.LETTER}
          />
        )}

        {/* フォローコール注文のSalesforce関連を表示 */}
        {!isLoading && item && item.follow_call_order && (item.follow_call_order.salesforce_sync_flag === FLAG.ON || item.follow_call_order.salesforce_sync_flag === FLAG.FAILED) && user && user.salesforce_integration_flag === 1 && (
          <SalesforceSyncStatus
            item={item.follow_call_order}
            type={ORDER_TYPES.FOLLOW_CALL}
          />
        )}
      </div>
    )
  }
}

ItemTitle.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object,
  isLoading: PropTypes.bool,
  user: PropTypes.object,
};


const mapStateToProps = (state) => {
  return {
    user: state.accountSetting.user,
  };
};

export default withStyles(styles)(connect(
  mapStateToProps
)(ItemTitle));



// WEBPACK FOOTER //
// ./src/components/OrderDetail/rows/ItemTitle.jsx